export const VALIDATE_RECAPTCHA_LOADING = 'REDUX_SAGA_VALIDATE_RECAPTCHA_LOADING';
export const VALIDATE_RECAPTCHA_SUCCESS = 'REDUX_SAGA_VALIDATE_RECAPTCHA_SUCCESS';
export const VALIDATE_RECAPTCHA_ERROR = 'REDUX_SAGA_VALIDATE_RECAPTCHA_ERROR';
export const VALIDATE_RECAPTCHA_RESET = 'REDUX_SAGA_VALIDATE_RECAPTCHA_RESET';


export const actionValidateRecaptchaToken = (dispatch, recaptchaToken, sessionID) => {
    dispatch({ type: VALIDATE_RECAPTCHA_LOADING, payload: { recaptchaToken: recaptchaToken, sessionID: sessionID } })
};

export const actionValidateRecaptchaReset = (dispatch) => {
    dispatch({ type: VALIDATE_RECAPTCHA_RESET })
};
